import rehabService from '@Apis/rehab.api';

export const fetchFieldMetadata = async <T>(
	endpoint: 'events' | 'tasks' | 'condition',
	systemType: string,
	assetType: string,
	standard: string,
): Promise<T[]> => {
	const response = await rehabService.get(`rehabTree/fieldsByRecordType/${endpoint}`, {
		params: {
			systemType,
			assetType,
			standard,
		},
	});

	return response.data.data;
};
